import { ValidationRunCoordinator } from './validationRunCoordinator';
import type { PcfValidationReport } from '../types';

let globalCoordinator: ValidationRunCoordinator<PcfValidationReport> | null = null;

export function getGlobalValidationRunCoordinator(): ValidationRunCoordinator<PcfValidationReport> {
  if (!globalCoordinator) {
    globalCoordinator = new ValidationRunCoordinator<PcfValidationReport>();
  }
  return globalCoordinator;
}

export function resetGlobalValidationRunCoordinator(): void {
  globalCoordinator = null;
}
